module.exports = __webpack_public_path__ + "static/media/dune_wake_up.12257287.mp3";